import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bonusomat-quests__hidden-card-titles"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "bonusomat-quests__arrows"
}
const _hoisted_4 = {
  key: 0,
  class: "bonusomat-quests__title bonusomat-quests__title--arrows"
}
const _hoisted_5 = { class: "bonusomat-quests__arrows" }
const _hoisted_6 = {
  key: 1,
  class: "bonusomat-placeholder bonusomat-placeholder--quests bonusomat-quests-carousel"
}
const _hoisted_7 = {
  key: 2,
  class: "bonusomat-placeholder bonusomat-placeholder--quests bonusomat-quests-carousel"
}
const _hoisted_8 = { class: "bonusomat-placeholder__absolute" }
const _hoisted_9 = { class: "bonusomat-quests-carousel__wrapper" }

import { ref, computed, watch, nextTick } from "vue";
import { useKeenSlider } from "keen-slider/vue.es";

import TypographyHeadline from "@sazka/design-system/src/typography/typography-headline.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import DsBadge from "@sazka/design-system/src/badge/ds-badge.vue";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import QuestDetail from "./bonusomat-quest-detail.vue";
import BonusomatQuestCard from "./bonusomat-quest-card.vue";
import ConfirmModal from "./bonusomat-quests-confirm-modal.vue";
import useBonusomatData from "../../composables/use-bonusomat-data";
import useBonusomatOnboarding from "../../composables/use-bonusomat-onboarding";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";

const noQuestMessage = "Na nový Quest se můžete těšit každou středu a neděli vždy od&nbsp;12:00";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-quests',
  setup(__props) {

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { bonusomatPlayerData, remainingSpinsCount, isPlayerDataLoaded } = bonusomatPlayerStatus;

const {
    hasActiveQuest,
    activeQuest,
    questsData,
    isQuestsDataLoaded,
    questCardProgressLoadCounter,
    questsDataHasError,
    isQuestModalOpen,
} = useBonusomatData();

const { openBonusomatOnboarding } = useBonusomatOnboarding();

const isBreakpointUpMd = useBreakpoints("md");
const isBreakpointUpLg = useBreakpoints("lg");

const elemQuestCardTitles = ref([]);
const maxTitleHeightComp = computed(() => {
    const titleLineHeight = isBreakpointUpLg.value ? 24 : 20;

    if (isQuestsDataLoaded.value) {
        return Math.max.apply(
            titleLineHeight,
            elemQuestCardTitles.value.map((el) => (el as HTMLElement)?.clientHeight ?? titleLineHeight)
        );
    }

    return titleLineHeight;
});

const isActiveQuestVisible = computed(() => hasActiveQuest.value && activeQuest.value);
const questsCount = computed(() => questsData.value?.length ?? 0);

const questsGrouped = computed(() => {
    if (!questsData.value?.length) return [];

    const sortedQuests = [...questsData.value].sort((questA, questB) => {
        if (questA.id == bonusomatPlayerData.value.activeQuestId) return -1;
        if (questB.id == bonusomatPlayerData.value.activeQuestId) return 1;

        if (questA.completed && !questB.completed) return 1;
        if (!questA.completed && questB.completed) return -1;

        const durationA = new Date(questA.endDate).getTime() - new Date(questA.startDate).getTime();
        const durationB = new Date(questB.endDate).getTime() - new Date(questB.startDate).getTime();

        return durationA - durationB;
    });

    if (isBreakpointUpMd.value && hasActiveQuest.value) {
        sortedQuests.splice(0, 1);
    }

    let groupedQuests = [];

    if (!isBreakpointUpMd.value || hasActiveQuest.value) {
        groupedQuests = sortedQuests.map((quest) => [quest]);
    } else {
        groupedQuests =
            sortedQuests?.reduce((result, _, index, array) => {
                if (index % 2 === 0) {
                    const group = [array[index]];
                    if (array.length > index + 1) group.push(array[index + 1]);

                    result.push(group);
                }
                return result;
            }, []) ?? [];
    }

    return groupedQuests;
});

const openBonusomatOnboardingClick = () => {
    openBonusomatOnboarding("quests");
    BonusomatDatalayer.pushMoreInfoClick("Questy", bonusomatPlayerData.value.points, remainingSpinsCount.value);
};

// CAROUSEL SETUP
const currentSlide = ref(0);
const maxIdx = ref(0);
const [container, slider] = useKeenSlider({
    selector: ".bonusomat-quests-carousel__item",
    slides: {
        perView: "auto",
        spacing: 12,
    },
    breakpoints: {
        "(min-width: 1024px)": {
            slides: {
                perView: "auto",
                spacing: 16,
            },
        },
        "(min-width: 1680px)": {
            slides: {
                perView: "auto",
                spacing: 20,
            },
        },
    },
    slideChanged(s) {
        currentSlide.value = s.track.details?.abs;
    },
    updated(s) {
        currentSlide.value = s.track.details?.abs;
        maxIdx.value = s.track.details?.maxIdx;
    },
    created(s) {
        currentSlide.value = s.track.details?.abs;
        maxIdx.value = s.track.details?.maxIdx;
    },
    optionsChanged(s) {
        currentSlide.value = s.track.details?.abs;
        maxIdx.value = s.track.details?.maxIdx;
    },
});

// CAROUSEL FUNCTIONS
const prevSlide = () => slider.value?.prev();
const nextSlide = () => slider.value?.next();

const isLeftButtonDisabled = computed(() => currentSlide.value === 0 || !questsCount.value);
const isRightButtonDisabled = computed(() => currentSlide.value >= maxIdx.value || !questsCount.value);

watch([activeQuest, questsCount, isBreakpointUpMd], () => {
    nextTick(() => {
        slider.value.update();
        slider.value.track.to(0);
    });
});

// CAROUSEL ARROW STATES
const areArrowsVisible = computed(() => {
    return (
        slider.value &&
        !(isBreakpointUpMd.value && hasActiveQuest.value) &&
        questsCount.value > (isBreakpointUpMd.value ? 2 : 1)
    );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isQuestsDataLoaded))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(questsData), (quest) => {
            return (_openBlock(), _createElementBlock("div", {
              key: quest.id,
              ref_for: true,
              ref_key: "elemQuestCardTitles",
              ref: elemQuestCardTitles,
              innerHTML: quest.title
            }, null, 8, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", {
      class: "bonusomat-quests",
      style: _normalizeStyle(`--minTitleHeight: ${maxTitleHeightComp.value}px`)
    }, [
      _createVNode(TypographyHeadline, { theme: "dark" }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createTextVNode(" Questy ")),
          _createVNode(DsBadge, {
            text: questsCount.value.toString(),
            class: "bonusomat-quests__quests-count"
          }, null, 8, ["text"]),
          _createVNode(DsButton, {
            type: "text",
            theme: "dark",
            "icon-right": "help",
            onClick: openBonusomatOnboardingClick,
            class: "button-onboarding"
          }),
          (areArrowsVisible.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(DsButton, {
                  theme: "dark",
                  type: "interaction",
                  size: "sm",
                  "icon-right": "arrow-left",
                  onClick: prevSlide,
                  "is-disabled": isLeftButtonDisabled.value
                }, null, 8, ["is-disabled"]),
                _createVNode(DsButton, {
                  theme: "dark",
                  type: "interaction",
                  size: "sm",
                  "icon-right": "arrow-right",
                  onClick: nextSlide,
                  "is-disabled": isRightButtonDisabled.value
                }, null, 8, ["is-disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1,
        __: [0]
      }),
      (isActiveQuestVisible.value && _unref(isBreakpointUpMd))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "bonusomat-quests__title" }, "Aktivní", -1)),
            _createVNode(BonusomatQuestCard, {
              quest: _unref(activeQuest),
              "progress-load-counter": 'activeQuest-' + _unref(questCardProgressLoadCounter).toString()
            }, null, 8, ["quest", "progress-load-counter"]),
            (questsGrouped.value.length)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_4, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Další Questy ")),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(DsButton, {
                      theme: "dark",
                      type: "interaction",
                      size: "sm",
                      "icon-right": "arrow-left",
                      onClick: prevSlide,
                      "is-disabled": isLeftButtonDisabled.value
                    }, null, 8, ["is-disabled"]),
                    _createVNode(DsButton, {
                      theme: "dark",
                      type: "interaction",
                      size: "sm",
                      "icon-right": "arrow-right",
                      onClick: nextSlide,
                      "is-disabled": isRightButtonDisabled.value
                    }, null, 8, ["is-disabled"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (!_unref(isQuestsDataLoaded) || !_unref(isPlayerDataLoaded))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (index) => {
                return _createElementVNode("div", {
                  key: index,
                  class: _normalizeClass(["bonusomat-placeholder__card bonusomat-quest-card bonusomat-placeholder__skeleton", index > 4 ? 'bonusomat-placeholder__card--hidden-on-desktop' : '']),
                  style: _normalizeStyle({
                    animationDelay: `${index * 0.1}s`,
                })
                }, null, 6)
              }), 64))
            ]))
          : (!questsCount.value && _unref(isQuestsDataLoaded) && _unref(isPlayerDataLoaded))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (index) => {
                  return _createElementVNode("div", {
                    key: index,
                    class: _normalizeClass(["bonusomat-placeholder__card bonusomat-quest-card", index > 4 ? 'bonusomat-placeholder__card--hidden-on-desktop' : ''])
                  }, null, 2)
                }), 64)),
                _createElementVNode("div", _hoisted_8, [
                  (!_unref(questsDataHasError))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "bonusomat-placeholder__text",
                        innerHTML: noQuestMessage
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "bonusomat-placeholder__text" }, "Při načítání Questů nastala chyba", -1)),
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bonusomat-placeholder__subtext" }, "Zkuste to prosím později", -1))
                      ], 64))
                ])
              ]))
            : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: "bonusomat-quests-carousel",
          ref_key: "container",
          ref: container
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questsGrouped.value, (questGroup, groupIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["bonusomat-quests-carousel__item", {
                        'bonusomat-quests-carousel__item--column': _unref(isBreakpointUpMd) && !isActiveQuestVisible.value,
                        'bonusomat-quests-carousel__item--active':
                            !_unref(isBreakpointUpMd) && _unref(hasActiveQuest) && groupIndex == 0,
                    }]),
              key: groupIndex
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questGroup, (quest) => {
                return (_openBlock(), _createBlock(BonusomatQuestCard, {
                  key: quest.id,
                  quest: quest,
                  "progress-load-counter": 
                            !_unref(isBreakpointUpMd) && _unref(hasActiveQuest) && groupIndex == 0
                                ? 'activeQuestSmall-' + _unref(questCardProgressLoadCounter).toString()
                                : undefined
                        ,
                  "use-calculated-title-height": _unref(isBreakpointUpMd) && _unref(isQuestsDataLoaded) && questsCount.value > 2
                }, null, 8, ["quest", "progress-load-counter", "use-calculated-title-height"]))
              }), 128))
            ], 2))
          }), 128))
        ], 512)
      ], 512), [
        [_vShow, questsCount.value && _unref(isQuestsDataLoaded) && _unref(isPlayerDataLoaded)]
      ]),
      (_unref(isQuestModalOpen))
        ? (_openBlock(), _createBlock(QuestDetail, { key: 3 }))
        : _createCommentVNode("", true),
      _createVNode(ConfirmModal)
    ], 4)
  ], 64))
}
}

})